export function QResizeBehavior() {
  this.fPinLeft = true;
  this.fPinTop = true;
  this.fPinRight = false;
  this.fPinBottom = false;
  this.fCustomResize = false;
  this.fPinCenter = false;
}
